import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import AutoJobHistories from '@/components/formats/RirekishoParts/AutoJobHistories.vue'
import NewRirekishoResetDialog from '@/components/format-edit/new-rirekisho/NewRirekishoResetDialog.vue'
import { useNewRirekishoFormatData } from '@/composables/format-edit/useNewRirekishoFormatData'
import { useNewRirekishoHistoriesApi } from '@/composables/format-edit/useNewRirekishoHistories'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRirekishoJobHistoryCard',
  props: {
    currentCardId: null,
    basicData: null,
    previewErrors: null
  },
  setup(__props: any) {

const descriptionMaxLength = 80



const formatData = useNewRirekishoFormatData()
const {
  activeHistoryItem,
  setJobHistories,
  resetJobHistories,
  addJobHistory,
  deleteJobHistory,
  moveJobHistory,
  activateHistoryItem
} = useNewRirekishoHistoriesApi()

const jobResetVisible = ref(false)

return { __sfc: true,descriptionMaxLength, formatData, activeHistoryItem, setJobHistories, resetJobHistories, addJobHistory, deleteJobHistory, moveJobHistory, activateHistoryItem, jobResetVisible, HistoryItem, AutoJobHistories, NewRirekishoResetDialog }
}

})